export interface StripeCustomerResponse {
  stripeCustomerId: string;
}

export interface StripePaymentMethodDto {
  paymentMethodId: string;
  type: string;
  cardBrand: string | null;
  cardLast4: string | null;
  cardExpMonth: number | null;
  cardExpYear: number | null;
  bankName: string | null;
  bankAccountLast4: string | null;
  bankAccountType: string | null;
  isDefault: boolean;
}

export type StripePaymentStatus =
  | 'pending' // Payment link created, awaiting payment
  | 'succeeded' // Payment completed successfully
  | 'failed' // Payment attempt failed
  | 'refunded' // Fully refunded
  | 'partially_refunded' // Partially refunded
  | 'disputed'; // Charge disputed by cardholder

// ── Stripe Setup Intent (ACH bank account) ────────────────────────────

export interface SetupIntentResponse {
  setupIntentId: string;
  clientSecret: string;
}
